import { ITEM_SESSION_STORAGE_CRUMBS } from '../components/Breadcrumb/utils/constants';

const useBreadcrumbsStorage = () => {
  const getCrumbs = () =>
    JSON.parse(sessionStorage.getItem(ITEM_SESSION_STORAGE_CRUMBS)) || [];

  const saveCrumbs = (crumbs) =>
    sessionStorage.setItem(
      ITEM_SESSION_STORAGE_CRUMBS,
      JSON.stringify(crumbs),
    );

  const updateLastCrumbLabel = (newTitle) => {
    const crumbs = getCrumbs();
    crumbs[crumbs.length - 1].label = newTitle;
    saveCrumbs(crumbs);
  };

  return { getCrumbs, saveCrumbs, updateLastCrumbLabel };
};

export default useBreadcrumbsStorage;
